import React from 'react';
import { Box, Typography, withStyles, Radio } from '@material-ui/core';
import { useMobileStyles } from '../styles';

const GreenRadio = withStyles((theme) => ({
  root: {
    padding: "0px !important",
    color: `${theme.palette.tertiary.radioButtonColor} !important`,
    "&$checked": {
      color: `${theme.palette.tertiary.radioButtonCheckedColor} !important`,
    },
    "&$disabled": {
      color: `${theme.palette.tertiary.radioButtonDisabledColor} !important`,
    },
  },
  checked: {},
  disabled: {},
}))((props) => (
  <Radio color="default" className={props.classes?.smallRadioButton} {...props} />
));

const EnergyModeSelector = ({ controlType, subTitle, controlTypeSubHeading, unit, smartDisabled, selectedValue, loading, onEnergyModeChange, children }) => {
  const classes = useMobileStyles();
  const isSmartCardDisabled = smartDisabled && controlType === 'Smart Mode';

  const checkRadio = () => {
    return selectedValue.local === controlType;
  };

  const handleModeSelect = () => {
    if (loading || isSmartCardDisabled || checkRadio()) {
      return;
    }

    onEnergyModeChange({ target: { value: controlType } }, smartDisabled, controlType);
  };

  return (
    <Box className={classes.dFlex}>
      <Box className={[classes.listCardRadio, isSmartCardDisabled && classes.disableRadio]} onClick={handleModeSelect}>
        <GreenRadio
          disabled={loading}
          checked={checkRadio()}
          onChange={(e) => onEnergyModeChange(e, smartDisabled, controlType)}
          value={controlType}
          name="radio-button-group"
        />
        <Box className={classes.cardHeadingWithRadio}>
          <Typography className={classes.cardHeading}>
            {controlType}
          </Typography>
        </Box>
      </Box>
      <Box className={[classes.modeHeaderContainer, isSmartCardDisabled && classes.disableRadio, selectedValue.local === controlType && classes.selectedRadioOption]} onClick={handleModeSelect}>
        <Typography className={classes.description}>{subTitle}</Typography>
      </Box>

      {selectedValue.local === controlType && (
        <>
          {children}
        </>
      )}
    </Box>
  );
};

export default EnergyModeSelector;
